<template>
  <div id="sdk">
    <Menu></Menu>
    <div class="box">
      <h1>联系我们</h1>
      <p>在线客服</p>
      <div class="zixun">
        <span>每天9:30-18:30</span>
        <a class="button" :href="wpaqq">在线咨询</a>
      </div>
      <p>媒体合作</p>
      <div class="zixun">
        <span>020-38800336</span>
      </div>
      <p>企业版合作</p>
      <div class="zixun">
        <span>021-58606986</span>
      </div>
      <p>帮助&反馈</p>
      <div class="zixun last">
        <span>help@todesk.com</span>
      </div>
    </div>
    <div class="map">
      <!-- <baidu-map
        class="bdwindow"
        :dragging="mapOption.dragging"
        :center="mapOption.center"
        :zoom="mapOption.zoom"
        style="height: 200px"
        :scroll-wheel-zoom="mapOption.scroll"
      >
        <bm-marker :position="mapOption.center" :dragging="true">
          <bm-label
            :content="mapOption.title"
            :labelStyle="{ color: 'red', fontSize: '12px' }"
            :offset="{ width: -15, height: 30 }"
          />
        </bm-marker>
      </baidu-map> -->
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Menu from "@/components/menu";
import Footer from "@/components/footer";
import { mapState } from "vuex";
export default {
  components: {
    Menu,
    Footer,
  },
  data() {
    return {
      // mapOption: {
      //   center: { lng: 110.346676, lat: 20.023767 },
      //   zoom: 16, //缩放级别
      //   title: "公司地址",
      //   scroll: true, //地图缩放
      //   dragging: true, //地图拖拽
      // },
    };
  },
  computed: {
    ...mapState(["wpaqq"]),
  },
  beforeCreate() {
    document.body.style.overflow = "visible";
  },
};
</script>

<style scoped>
.box {
  width: 100%;
  background: url("../assets/contact/contact.png") no-repeat;
  background-size: 100% 100%;
}
.box h1 {
  height: 27px;
  font-size: 19px;
  font-family: PingFang-SC-Bold, PingFang-SC;
  font-weight: bold;
  color: #1f2329;
  line-height: 27px;
  margin: 0;
  padding-top: 53px;
  padding-left: 20px;
  padding-bottom: 41px;
}
.box p {
  height: 24px;
  font-size: 17px;
  font-family: PingFangSC-Bold, PingFang SC;
  font-weight: bold;
  color: #1f2329;
  line-height: 24px;
  padding-left: 20px;
  padding-bottom: 8px;
  margin: 0;
}
.box > span {
  height: 20px;
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #1f2329;
  line-height: 20px;
  padding-left: 20px;
}
.box .zixun {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 20px 24px 20px;
  border-bottom: 1px solid #e7e7e7;
  padding-bottom: 24px;
}
.box .zixun.last{
  margin: 0 20px 0px 20px;
  border-bottom:none;
}
.box .zixun span {
  height: 28px;
  font-size: 20px;
  font-family: PingFangSC-Bold, PingFang SC;
  font-weight: bold;
  color: #1f2329;
  line-height: 28px;
}
.box .zixun .button {
  display: block;
  width: 72px;
  line-height: 30px;
  background: #107bf5;
  border-radius: 4px;
  font-size: 12px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #ffffff;
  text-align: center;
}
.map {
  /* width: 100%; */
  background: white;
  padding: 19px 20px;
}
.problem {
  padding: 20px;
  background: white;
}
.problem h3 {
  height: 23px;
  font-size: 16px;
  font-family: PingFangSC-Bold, PingFang SC;
  font-weight: bold;
  color: #1f2329;
  line-height: 23px;
  margin: 0;
}
.van-cell__title span {
  width: 231px;
  height: 20px;
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #1f2329;
  line-height: 20px;
}
</style>
